import { SUBSCRIPTIONS_TYPES_ENUM } from '@/const';
import { ClientExtendedSubscription } from '@/layouts/subscription/subscriptionType';

export default function hasSubscriptionType(
	subscriptions: ClientExtendedSubscription[],
	type: keyof typeof SUBSCRIPTIONS_TYPES_ENUM,
): boolean {
	return (subscriptions || [])?.some((sub) =>
		sub?.type?.toLowerCase()?.includes(type),
	);
}
